<div ras-render-element
    (open)="onOpen( $event )"
    (jump)="onPageJump($event)"
    [content]="content">
</div>
